import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./acoesFormulario-jss";

type Props = {
  classes?: any;
  children: React.ReactNode;
  submitCount?: number;
};

export function AcoesFormulario({ classes, children, submitCount = 0 }: Props) {
  const referencia = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (submitCount === 0 || !referencia.current) {
      return undefined;
    }
    const formulario = referencia.current.closest("form");
    if (!formulario) {
      return undefined;
    }
    // Formik so preenche os erros no ciclo seguinte ao incremento de submitCount
    const temporizador = window.setTimeout(() => {
      const invalido = formulario.querySelector('[aria-invalid="true"], .Mui-error') as HTMLElement | null;
      if (invalido && invalido.scrollIntoView) {
        invalido.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    }, 0);
    return () => window.clearTimeout(temporizador);
  }, [submitCount]);

  return (
    <div ref={referencia} className={classes.acoes}>
      {children}
    </div>
  );
}

export default withStyles(styles as any)(AcoesFormulario);
